import { useQuery } from "hooks/useQuery";
import { getActiveStrategies } from "../service";

export const useDashboardActiveStrategies = () => {
  const { isLoading, data, error, refetch } = useQuery({
    key: "dashboardActiveStrategies",
    queryKey: ["dashboardActiveStrategies"],
    queryFn: () => getActiveStrategies(),
  });

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
